import React from 'react';

function CustomerNameFieldAdmin({ data }) {
  if (data.customer && data.customer.type === 'AZIENDA') {
    return <>{data.customer.businessName}</>;
  } else if (data.customer && data.customer.type === 'PRIVATO') {
    return (
      <>
        {data.customer.name} {data.customer.surname}
      </>
    );
  } else if (data.customer) {
    return <>{data.customer.name}</>;
  } else {
    return <>-</>;
  }
}

export default CustomerNameFieldAdmin;
